// extracted by mini-css-extract-plugin
module.exports = {"globalLoader":"globalLoader___3GspZ"};